import type { Env } from 'types';

import * as sizes from '../domain/sizes';

export type Region = {
  adjective: string;
  baseUrl: string;
  code: string;
  domain: string;
  flag: string;
  lang: string;
  name: string;
  sizes: string[];
  timeZone: string;
  tld: string;
};

function getEnvValue<K extends keyof Env>(key: K): Env[K] | undefined {
  if (typeof window !== 'undefined') {
    return window.env?.[key];
  } else {
    return process.env[key] as Env[K] | undefined;
  }
}

function getSiteBaseUrl(tld: string) {
  const subDomain = getEnvValue('SUB_DOMAIN');

  return `https://${subDomain ? `${subDomain}.` : ''}thesolesupplier${tld}`;
}

export const regions: Region[] = [
  {
    adjective: 'UK',
    baseUrl: getSiteBaseUrl('.co.uk'),
    code: 'GB',
    domain: 'thesolesupplier.co.uk',
    flag: '🇬🇧',
    lang: 'en',
    name: 'UK',
    sizes: sizes.ukSizes,
    timeZone: 'Europe/London',
    tld: '.co.uk'
  },
  {
    adjective: 'German',
    baseUrl: getSiteBaseUrl('.de'),
    code: 'DE',
    domain: 'thesolesupplier.de',
    flag: '🇩🇪',
    lang: 'de',
    name: 'Germany',
    sizes: sizes.euSizes,
    timeZone: 'Europe/Berlin',
    tld: '.de'
  }
];

export const DEFAULT_REGION = regions[0]!;

function getOverride(url: URL) {
  const override = url.searchParams.get('regionCode')?.toLowerCase() ?? '';

  return regions.find(({ code }) => code === override.toUpperCase());
}

export function getRegion(url: URL): Region {
  const override = getOverride(url);

  if (override) return override;

  return regions.find((r) => url.host.endsWith(r.tld)) ?? DEFAULT_REGION;
}
